import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./Projects.css";
import Zoom from "react-reveal/Zoom";

const AllProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <Container
      style={{ backgroundColor: "black", color: "white" }}
      className="py-4"
    >
      <Zoom bottom>
        <p className="text-white text-center fw-bold fs-1">All Projects</p>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 w-100 ps-4 py-4">
          {projects.map((project) => (
            <div key={project.id} className="col text-center flip-box">
              <div className="card h-100 rounded rounded-3 card1">
                <img src={project.img} className="card-img-top" alt="..."></img>
                <div className="card-body">
                  <h4 className="card-title">{project.name}</h4>
                  <p>
                    <span className="fw-bold">Technology Used:</span>{" "}
                    {project.technology}
                  </p>
                </div>
                <div className="card-footer text-center">
                  <button className="btn btn-success mx-2 my-2">
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      href={project.live}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fas fa-link text-white"></i> Live Site
                    </a>
                  </button>
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/projectDetails/${project.id}`}
                  >
                    <button className="btn btn-success mx-2 my-2">
                      <i className="fas fa-info-circle text-white"></i> View
                      Details
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Zoom>
    </Container>
  );
};

export default AllProjects;
